import React, {useEffect, useState} from 'react';
import SideDrawer from "../../../Components/Advertisers/SideDrawer";
import {
  Container,
  Grid,
  List,
  ListItem,
  Avatar,
  ListItemText,
  ListItemAvatar,
  makeStyles,
  ListItemSecondaryAction,
  Button,
  Divider,
} from "@material-ui/core";
import useAxios from "axios-hooks";
import {Alert} from "@material-ui/lab";
import moment from "moment";
import {Link} from "react-router-dom";


import campaignIcon from '../../../Assets/campaign-icon.png';
import CustomText from "../../../Components/Universal/CustomText";
import {getCampaigns} from "../../../Api";

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  },
  mainButton: {
    '&:hover': {
      backgroundColor: '#03A9F4',
    }
  }
}));

const CampaignsView = (props) => {
  const classes = useStyles();
  const [errorMsg, setErrorMsg] = useState('');
  const [campaigns, setCampaigns] = useState([]);
  const [{error, loading, response}] = useAxios(getCampaigns({page: 1}), {manual: false});

  useEffect(() => {
    if (response && response.data) {
      if (response.data.error) {
        setErrorMsg(response.data.message);
        return;
      }

      setCampaigns(response.data.campaigns);
    } else if (error) {
      setErrorMsg('Unable to fetch data from server, please try again later.');
    }
  }, [error, loading, response]);

  const goToCampaignPage = id => () => {
    props.history.replace(`/advertiser/campaigns/${id}`);
  };

  return (
    <SideDrawer>
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CustomText
              text={`Campaigns`}
              style='titleLarge'
              margin='40px 0 0 0'
            />
          </Grid>
          <Grid item xs={12}>
            {errorMsg && errorMsg.length > 0 && (
              <Alert severity="error">{errorMsg}</Alert>
            )}
            <List className={classes.root}>
              {campaigns.map((campaign, i) => ([
                <ListItem alignItems="center" key={campaign.id}>
                  <ListItemAvatar>
                    <Avatar alt={campaign.question} src={campaign.campaignImage || campaignIcon} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={campaign.questionText}
                    secondary={
                      <>
                        <strong>Type:</strong> {campaign.campaignType}<br />
                        <strong>Responses:</strong> {campaign.totalResponses}<br />
                        <strong>Started at:</strong> {moment(campaign.launchDate).format('MMMM D ha')}<br />
                      </>
                    }
                  />
                  <ListItemSecondaryAction>
                    <Button
                      aria-label="View Campaign Details"
                      color="primary"
                      variant="outlined"
                      onClick={goToCampaignPage(campaign.id)}
                      className={classes.mainButton}
                    >
                      View More
                    </Button>
                  </ListItemSecondaryAction>
                </ListItem>,
                  (i < (campaigns.length - 1) && <Divider key={campaign.id + i} variant="inset" component="li" />)
                ]
              ))}
            </List>
          </Grid>
        </Grid>
      </Container>
    </SideDrawer>
  );
};

export * from "./Create";
export default CampaignsView;
